<template>
    <div>
        <div class="margin-top-10 display-flex justify-content-space-between">
            <!-- <div class="name-leson">
                <h4>
                    <strong>{{ dataElectronicLecture.name }}</strong>
                </h4>
            </div> -->
            <div class="wrap-btn-add-chapter">
                <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                    @click="handleAddChapter" v-if="isEdit == 1">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Thêm chương
                </a>
            </div>
        </div>

        <vueCustomScrollbar v-if="listChapterClassSchool.length > 0"  class="b-chapter-scroll">
            <ChapterClassSchool @handleDeleteChapter="handleDeleteChapter"
                        @handleEditChapter="handleEditChapter" @handleAddPost="handleAddPost" :item="item"
                        v-for="(item, index) of listChapterClassSchool" :key="index"
                        @handleToggerCollapse="handleToggerCollapse" :isEdit="isEdit">
                        <template v-slot:post>
                            <b-collapse class="mt-2" :visible="item.isCollapse">
                                <vueCustomScrollbar class="b-post-scroll">
                                    <PostClassSchool :item="post" @handleEditPost="handleEditPost"
                                        @handleDeletePost="handleDeletePost" @handleAddDocument="handleAddDocument"
                                        v-for="(post, indexPost) of item.listPostClassSchool" :key="indexPost"
                                        :isEdit="isEdit">
                                        <template v-slot:document>
                                            <DocumentClassSchool @handleEditDocument="handleEditDocument"
                                                @handleViewDocument="handleViewDocument"
                                                @handleDeleteDocument="handleDeleteDocument" :item="document"
                                                v-for="(document, indexDocument) of post.listDocumentClassSchool"
                                                :key="indexDocument" :isEdit="isEdit" />
                                        </template>
                                    </PostClassSchool>
                                </vueCustomScrollbar>
                            </b-collapse>
                        </template>
                    </ChapterClassSchool>
            </vueCustomScrollbar>
        <div v-else class="text-center">Bài giảng chưa có nội dung</div>
        <!-- <div class="row pagination container m-0">
                <b-pagination
                pills 
                v-model="paramQueryData.pageIndex"
                :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize"
                first-number
                last-number
                ></b-pagination>
            </div> -->
        <ModalCreateUpdateChapter :type="paramQueryData.type" :chapterId="chapterClassSchoolIdCurrent"
            v-if="isOpenModalCreateUpdateChapter" @closeModal="closeModalCreateUpdateChapter"
            @handleDone="handleDone" />
        <ModalDeleteChapter v-if="isOpenModalDeleteChapter" @handleDeleteDone="handleDeleteDone"
            @closeModal="closeModalDeleteChapter" :chapterId="chapterClassSchoolIdCurrent" />

        <ModalCreateUpdatePost :chapterId="chapterClassSchoolIdCurrent" :posterId="posterClassSchoolIdCurrent"
            v-if="isOpenModalCreateUpdatePoster" @closeModal="closeModalCreateUpdatePoster"
            @handleDone="handleDonePoster" />

        <ModalDeletePost v-if="isOpenModalDeletePost" @handleDeleteDone="handleDeletePostDone"
            @closeModal="closeModalDeletePost" :posterId="posterClassSchoolIdCurrent" />

        <ModalCreateUpdateDocument :chapterId="chapterClassSchoolIdCurrent" :postId="posterClassSchoolIdCurrent"
            :documentId="documentClassSchoolIdCurrent"
            @handleDoneModalPrepareQuestions="handleDoneModalPrepareQuestions" v-if="isOpenModalCreateUpdateDocument"
            @closeModal="closeModalCreateUpdateDocument" @handleDone="handleDoneDocument" />

        <ModalDeleteDocument v-if="isOpenModalDeleteDocument" @handleDeleteDone="handleDeleteDocumentDone"
            @closeModal="closeModalDeleteDocument" :documentId="documentClassSchoolIdCurrent" />

        <ModalCreateUpdatePrepareQuestions :documentName="documentNameCurrent"
            :documentId="documentClassSchoolIdCurrent" @closeModal="closeModalPrepareQuestions"
            @handleDone="handleDonePrepareQuestions" v-if="isShowModalCreateUpdatePrepareQuestions" />

        <ModalViewDocument :item="itemSelected" v-if="isOpenModalViewDocument" @closeModal="closeModalViewDocument" />

    </div>
</template>
<script>
import { TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK } from './../../../constants/constants_enum'

import ModalCreateUpdateChapter from './ModalCreateUpdateChapter'
import ChapterClassSchool from './ChapterClassSchool.vue'
import { listChapterClassSchool, changeOrderChapter } from './../../../_api/chapterClassSchoolServices'
import PostClassSchool from './PostClassSchool'
import ModalDeleteChapter from './ModalDeleteChapter'
import ModalCreateUpdatePost from './ModalCreateUpdatePost'
import ModalDeletePost from './ModalDeletePost'
import ModalCreateUpdateDocument from './ModalCreateUpdateDocument'
import DocumentClassSchool from './DocumentClassSchool'
import ModalDeleteDocument from './ModalDeleteDocument'
import ModalCreateUpdatePrepareQuestions from './ModalCreateUpdatePrepareQuestions'
import draggable from 'vuedraggable'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ModalViewDocument from './../../../_components/ModalViewDocument.vue'
export default {
    components: {
        ModalCreateUpdateChapter,
        ChapterClassSchool,
        PostClassSchool,
        ModalDeleteChapter,
        ModalCreateUpdatePost,
        ModalDeletePost,
        ModalCreateUpdateDocument,
        DocumentClassSchool,
        ModalDeleteDocument,
        ModalCreateUpdatePrepareQuestions,
        draggable,
        vueCustomScrollbar,
        ModalViewDocument
    },
    props: {
        dataElectronicLecture: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        isEdit: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            FILE_LINK,
            itemSelected: null,
            isOpenModalViewDocument: false,
            dragging: false,
            isOpenModalCreateUpdateChapter: false,
            isOpenModalCreateUpdatePoster: false,
            isOpenModalCreateUpdateDocument: false,
            isOpenModalDeleteDocument: false,
            paramQueryData: {
                lessonClassSchoolId: this.dataElectronicLecture.id,
                type: 2,
                keyword: '',
                pageIndex: 1,
                pageSize: 6000000,
            },
            listChapterClassSchool: [],
            totalRecords: 0,
            chapterClassSchoolIdCurrent: 0,
            posterClassSchoolIdCurrent: 0,
            documentClassSchoolIdCurrent: 0,
            documentNameCurrent: '',
            isOpenModalDeleteChapter: false,
            isOpenModalDeletePost: false,
            isShowModalCreateUpdatePrepareQuestions: false,
            chapterSelectCurrent: null,
            itemChapterCollapse : null
        }
    },
    mounted() {
        this.getListChapterClassSchool()
    },
    methods: {
        handleViewDocument(document) {
            this.itemSelected = document
            if (document.typeDocument == FILE_LINK) {
                window.open(document.path, '_blank');
            }
            else {
                this.isOpenModalViewDocument = true
            }
        },
        closeModalViewDocument() {
            this.isOpenModalViewDocument = false
        },
        onChangeDrag(event) {
            console.log(event)
        },
        onDragStart(event) {
            this.dragging = true
        },
        onDragEnd(event) {
            let listOrder = []

            for (let i = 0; i < this.listChapterClassSchool.length; i++) {
                const item = this.listChapterClassSchool[i];
                listOrder.push(Number(item.orderNo))
            }

            listOrder.sort(function (a, b) {
                return a-b;
            })

            let listParams = []
            for (let i = 0; i < this.listChapterClassSchool.length; i++) {
                const item = this.listChapterClassSchool[i];
                listParams.push({ id: item.id, orderNo: listOrder[i] })
            }
            changeOrderChapter(listParams)

            this.dragging = false
        },
        handleToggerCollapse(item) {
            for (let i = 0; i < this.listChapterClassSchool.length; i++) {
                if (this.listChapterClassSchool[i].id != item.id) {
                    this.listChapterClassSchool[i].isCollapse = false
                }
            }
            item.isCollapse = !item.isCollapse
            if(item.isCollapse){
                this.itemChapterCollapse = item
            }
        },
        handleDonePrepareQuestions() {
            this.getListChapterClassSchool()
            this.closeModalPrepareQuestions()
        },
        handleDoneModalPrepareQuestions(data) {
            this.documentClassSchoolIdCurrent = data.id
            this.documentNameCurrent = data.name
            this.isShowModalCreateUpdatePrepareQuestions = true
        },
        closeModalPrepareQuestions() {
            this.isShowModalCreateUpdatePrepareQuestions = false
            this.getListChapterClassSchool()
        },
        handleDeleteDocument(item) {
            this.documentClassSchoolIdCurrent = item.id
            this.isOpenModalDeleteDocument = true
        },
        handleEditDocument(item) {
            this.documentClassSchoolIdCurrent = item.id
            this.chapterClassSchoolIdCurrent = item.chapterId
            this.posterClassSchoolIdCurrent = item.id
            this.isOpenModalCreateUpdateDocument = true
        },
        handleDeleteDocumentDone() {
            this.getListChapterClassSchool()
            this.closeModalDeleteDocument()
        },
        closeModalDeleteDocument() {
            this.isOpenModalDeleteDocument = false
        },
        handleAddDocument(item) {

            this.documentClassSchoolIdCurrent = 0
            this.chapterClassSchoolIdCurrent = item.chapterId
            this.posterClassSchoolIdCurrent = item.id
            this.isOpenModalCreateUpdateDocument = true
        },
        handleDoneDocument() {
            this.getListChapterClassSchool()
            this.closeModalCreateUpdateDocument()
        },
        closeModalCreateUpdateDocument() {
            this.isOpenModalCreateUpdateDocument = false
        },
        handleDeletePost(item) {
            this.posterClassSchoolIdCurrent = item.id
            this.isOpenModalDeletePost = true
        },
        closeModalDeletePost() {
            this.isOpenModalDeletePost = false
        },
        handleDeletePostDone() {
            this.getListChapterClassSchool()
            this.closeModalDeletePost()
        },
        handleEditPost(item) {
            console.log(`chapter:${item.chapterId},post:${item.id}`)
            this.chapterClassSchoolIdCurrent = item.chapterId
            this.posterClassSchoolIdCurrent = item.id
            this.isOpenModalCreateUpdatePoster = true
        },
        handleAddPost(item) {
            //oke
            console.log('chapter:', item.id)
            this.posterClassSchoolIdCurrent = 0
            this.chapterClassSchoolIdCurrent = item.id
            this.chapterSelectCurrent = item
            this.isOpenModalCreateUpdatePoster = true
        },
        handleDonePoster() {
            this.getListChapterClassSchool()
            this.closeModalCreateUpdatePoster()
        },
        closeModalCreateUpdatePoster() {
            this.isOpenModalCreateUpdatePoster = false
        },
        closeModalDeleteChapter() {
            this.isOpenModalDeleteChapter = false
        },
        handleDeleteDone() {
            this.getListChapterClassSchool()
            this.closeModalDeleteChapter()
        },
        handleDeleteChapter(item) {
            this.chapterClassSchoolIdCurrent = item.id
            this.isOpenModalDeleteChapter = true
        },
        handleEditChapter(item) {
            console.log(item)
            this.chapterClassSchoolIdCurrent = item.id
            this.isOpenModalCreateUpdateChapter = true
        },
        handleAddChapter() {
            //set
            this.chapterClassSchoolIdCurrent = 0
            this.isOpenModalCreateUpdateChapter = true
            this.itemChapterCollapse=null
        },
        closeModalCreateUpdateChapter() {
            this.isOpenModalCreateUpdateChapter = false
        },
        handleDone() {
            this.getListChapterClassSchool()
            this.closeModalCreateUpdateChapter()
        },
        getListChapterClassSchool() {
            let self = this
            listChapterClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listChapterClassSchool = res.data.list
                    self.listChapterClassSchool.forEach(element => {
                        if (element.id ==(this.itemChapterCollapse?this.itemChapterCollapse.id:0)) {
                            element.isCollapse = true
                        }
                    });
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.margin-top-10 {
    margin-top: 20px;
}

.justify-content-space-between {
    justify-content: space-between
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.b-chapter-scroll {
    max-height: 63vh;
    overflow-y: auto;
}

.b-post-scroll {
    max-height: 30vh;
    overflow-y: auto;
}
</style>